/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Used for configuring bundles and white-listing modules
 *
 * @returns {Object.<Promise>} default - list of modules that need to be served in separate bundles
 * @param {string} [property]          - module alias (alias for route path also)
 * @param {string} webpackChunkName    - bundle name
 * @param {string} import(arg)         - path to module
 *
 */
import DashboardWrapper from '@/components/_modules/DashboardWrapper'
import Dashboard from '@/components/_modules/Dashboard'

import Login from '@/components/Login'
import MfaSetup from '@/components/Login/mfa-setup'
import CreateProgram from '@/components/_modules/Programs/create'

import AdminSettings from '@/components/_modules/Admin/settings'
import ApprovalList from '@/components/_modules/Approvals/Approval-list'
import BUAndCCSettings from '@/components/_modules/BusinessUnitsAndCostCenters/BU-and-CC-settings'
import FundingInvAndAPSettings from '@/components/_modules/FundingInvoiceAndAPSettings'

import ImportModule from '@/components/_modules/Import'
import ImportPrograms from '@/components/_modules/Import/programs'
import ImportExpenses from '@/components/_modules/Import/expenses'
import ImportInvoices from '@/components/_modules/Import/invoices'

import InvoiceToPay from '@/components/_modules/I2P'
import InvoiceScan from '@/components/_modules/InvoiceScan/Queue'
import InvoiceScanHistory from '@/components/_modules/InvoiceScan/History'

import RejectAll from '@/components/_modules/Dashboard/reject-all'

import ApproveAll from '@/components/_modules/Dashboard/approve-all'

import Payment from '@/components/_modules/Payment'
import PaymentSendAPFile from '@/components/_modules/Payment/SendApFile'

import AddSupplier from '@/components/_modules/Suppliers/add-supplier'
import Insurance from '@/components/_modules/Network/Insurance/suppliers'
import InsuranceDetails from '@/components/_modules/Network/Insurance/suppliers-details'

import SuppliersInvoicesPayments from '@/components/_modules/Programs/Invoice-payments-received'
import SuppliersInvoices from '@/components/_modules/Programs/Invoice-sent'
import SuppliersInvoicesActionRequired from '@/components/_modules/Programs/Invoice-sent-cta'
import SuppliersRemitPayment from '@/components/_modules/Invoices/suppliers-remit-payment'
import SuppliersEditInvoice from '@/components/_modules/Invoices/suppliers-edit-invoice'
import Products from '@/components/_modules/Products/Products'

import Account from '@/components/_modules/Programs/Card-accounts'
import Cards from '@/components/_modules/Programs/Card-cards'
import Transactions from '@/components/_modules/Programs/Card-transactions'
import Envelopes from '@/components/_modules/Programs/Card-envelopes'
import List from '@/components/_modules/Programs/Card-list'

import EvedPay from '@/components/_modules/EvedPay'
import EvedPayCards from '@/components/_modules/EvedPay/cards'
import EvedPayTransactions from '@/components/_modules/EvedPay/transactions'
import EvedPayCardTransactions from '@/components/_modules/EvedPay/cardtransactions'
import EvedPayCardDetails from '@/components/_modules/EvedPay/details'
import EvedPayCardTransactionDetails from '@/components/_modules/EvedPay/transactiondetails'
import EvedPayCardRequestPhysicalCard from '@/components/_modules/EvedPay/requestPhysicalCard'
import EvedPayCardChangePin from '@/components/_modules/EvedPay/changePin'
import EvedPayShowCardNumber from '@/components/_modules/EvedPay/showCardNumber'
import EvedPayCardRequestAddFunds from '@/components/_modules/EvedPay/requestAddFunds'

import ReviewEmailPage from '@/components/_modules/I2P/ReviewEmailPage'

import ReverseApFile from '@/components/_modules/Payment/ReverseApFile'
import CorrectApFile from '@/components/_modules/Payment/CorrectApFile'

export default {
  // EvedPay
  EvedPay: {
    module: EvedPay,
    layout: 'mobile'
  },
  'evedpay/cards': {
    module: EvedPayCards,
    layout: 'mobile'
  },
  'evedpay/transactions': {
    module: EvedPayTransactions,
    layout: 'mobile'
  },
  'evedpay/cardtransactions': {
    module: EvedPayCardTransactions,
    layout: 'mobile'
  },
  'evedpay/details': {
    module: EvedPayCardDetails,
    layout: 'mobile'
  },
  'evedpay/transactiondetails': {
    module: EvedPayCardTransactionDetails,
    layout: 'mobile'
  },
  'evedpay/requestcard': {
    module: EvedPayCardRequestPhysicalCard,
    layout: 'mobile'
  },
  'evedpay/changepin': {
    module: EvedPayCardChangePin,
    layout: 'mobile'
  },
  'evedpay/shownumber': {
    module: EvedPayShowCardNumber,
    layout: 'mobile'
  },
  'evedpay/loadfunds': {
    module: EvedPayCardRequestAddFunds,
    layout: 'mobile'
  },

  // Login module
  Login: {
    module: Login,
    layout: 'auth'
  },
  MfaSetup: {
    module: MfaSetup,
    layout: 'auth'
  },

  // Reject all module
  RejectAll: {
    module: RejectAll,
    layout: 'main'
  },

  // Approve all module
  ApproveAll: {
    module: ApproveAll,
    layout: 'main'
  },

  // Programs module (currenly marked as notImplemented)
  Programs : {
    notImplemented: 'yet',
    pack   : utils.include('Programs'),
    module : () => import(/* webpackChunkName: "base"  */ './Programs'),
    layout : 'main'
  },
  // generic
  'Programs/create': {
    module: CreateProgram,
    layout: 'navless'
  },

  // Reporting module (currenly marked as notImplemented)
  Reports  : {
    notImplemented: true,
    module : () => import(/* webpackChunkName: "base"  */ './Reports')
  },

  // Network module (currenly marked as notImplemented)
  // Network  : () => import(/* webpackChunkName: "other" */ './Maps'),
  Network: {
    entry: '/i/Network/SupplierNetwork/'
  },
  'Network/add-supplier': {
    module: AddSupplier
  },
  'Network/insurance-management': {module: Insurance},
  'Network/insurance-view-details': { module: InsuranceDetails, layout: 'navless' },

  // Dashboards module (-currenly marked as notImplemented-)
  Dashboard: {
    layout: 'main'
  },
  'Dashboard/My': { module: DashboardWrapper, layout: 'main' },
  'Dashboard/MyDashboard': { module: Dashboard, layout: 'main' },

  // Administration module (partly implemented)
  Admin: {
    entry: '/d/Admin/Settings/'
  },
  'Admin/Settings': AdminSettings,
  'Admin/Approval-list': ApprovalList,
  'Admin/BusinessUnitsAndCostCenters': BUAndCCSettings,
  'Admin/FundingInvoiceAndAPFileTemplate': FundingInvAndAPSettings,

  // Import module (part of Admin)
  'Admin/Import': ImportModule,
  'Import/Programs': ImportPrograms,
  'Import/Expenses': ImportExpenses,
  'Import/Invoices': ImportInvoices,

  // (currenly marked as notImplemented)
  // Invoices : { notImplemented: true },
  Products: { notImplemented: true },
  Company: { notImplemented: true },
  'InvoiceToPay/upload': InvoiceToPay,
  'Invoice/upload': { module: InvoiceToPay, layout: 'navless' },
  'Payment/submit': Payment,
  'Payment/apfile': PaymentSendAPFile,

  // Invoice Scanning
  'InvoiceScan/queue': { module: InvoiceScan, layout: 'navless' },
  'InvoiceScan/history': { module: InvoiceScanHistory, layout: 'navless' },

  // Supplier Invoices
  Invoices: {
    entry: '/d/Invoices/sent'
  },
  'Invoices/payments': SuppliersInvoicesPayments,
  'Invoices/sent': SuppliersInvoices,
  'Invoices/action-required': SuppliersInvoicesActionRequired,

  'Invoices/remit-payment': SuppliersRemitPayment,
  'Invoices/edit': SuppliersEditInvoice,

  'Programs/Products': Products,

  'Programs/Card/accounts': Account,
  'Programs/Card/cards': Cards,
  'Programs/Card/transactions': Transactions,
  'Programs/Card/envelopes': Envelopes,
  'EnvelopeApprovalDashboard': { module: Envelopes, layout: 'navless' },
  'Programs/Card/list': List,
  'Invoice/review-email': { module: ReviewEmailPage, layout: 'navless' },

  'Programs/Invoice-AP/reverse': ReverseApFile,
  'Programs/Invoice-AP/correct': CorrectApFile
}



// WEBPACK FOOTER //
// ./src/components/_modules/bundles.pack.js